import _defineProperty from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/defineProperty';
import _toConsumableArray from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/toConsumableArray';
import _getIterator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/get-iterator';
import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from '~/plugins/axios.js';
import domain from '~/plugins/domain.js';

import UploadFilePanel from '~/components/mainPage/bookModuleSession/UploadFilePanel.vue';

export default {
  name: 'applicant-list',
  components: {
    UploadFilePanel: UploadFilePanel
  },
  data: function data() {
    return {
      currentMs: this.$store.state.currentModuleSession,
      currentMsApplicantList: this.$store.state.currentMsApplicantList,
      tableFields: {
        fullName: {
          key: 'fullname',
          label: 'Applicant Name'
        },
        nricFin: {
          key: 'nricFin',
          label: 'Nric / Fin'
        },
        conEmail: {
          key: 'conEmail',
          label: 'Contractor Email'
        },

        actions: {
          key: 'actions',
          label: 'Actions'
        }
      },
      modalInfo: {
        title: '',
        content: {}
      }
    };
  },
  mounted: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.initApplicants();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  updated: function updated() {},

  methods: {
    // ========== INIT APPLICANTS LIST =============
    initApplicants: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var currentMsId, managers, applicantList, seatTakenUpdate;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                currentMsId = this.$store.state.currentModuleSession.id;

                console.log('\n\n ========= ApplicantList.vue -currentMsId ========\n', currentMsId, '\n =======================');

                _context2.next = 4;
                return axios.get('/userMsManager/' + currentMsId);

              case 4:
                managers = _context2.sent.data;
                _context2.next = 7;
                return this.getApplicantList(managers);

              case 7:
                applicantList = _context2.sent;
                _context2.next = 10;
                return axios.get('/moduleSession/' + currentMsId);

              case 10:
                seatTakenUpdate = _context2.sent.data;


                this.$store.commit('setcurrentMsManagerList', managers);
                this.$store.commit('setcurrentMsApplicantList', applicantList);
                this.$store.commit('setModuleSession', seatTakenUpdate);
                this.$parent.getSeatTakenCount(seatTakenUpdate);
                this.currentMs = seatTakenUpdate;
                console.log('\n\n======= ApplicantList.vue - ApplicantList ======', applicantList);
                console.log('\n\n======= ApplicantList.vue - currentMsManager List ======', managers);

                return _context2.abrupt('return', { managers: managers });

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initApplicants() {
        return _ref2.apply(this, arguments);
      }

      return initApplicants;
    }(),


    // =========== GET APPLICANTS THRU managers =============
    getApplicantList: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(managers) {
        var applicantList, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, m, userActorId, msStatusId, msStatusCode, user;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                applicantList = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 4;
                _iterator = _getIterator(managers);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 21;
                  break;
                }

                m = _step.value;
                userActorId = m.userActorId;
                msStatusId = 'msStatus' + this.$store.state.currentModuleSession.id + userActorId;
                _context3.next = 12;
                return axios.post('/userMsStatus/userMsStatusCode', { msStatusId: msStatusId });

              case 12:
                msStatusCode = _context3.sent.data.msStatusCode;

                if (!(msStatusCode == 100)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 16;
                return axios.get('/users/' + userActorId);

              case 16:
                user = _context3.sent.data;

                if (this.$store.state.authUser.flag === "Admin" || this.$store.state.authUser.flag === "Trn") {
                  applicantList.push(user);
                } else if (this.$store.state.authUser.flag === "Con" && this.$store.state.authUser.companyName === user.companyName) {
                  applicantList.push(user);
                }

              case 18:
                _iteratorNormalCompletion = true;
                _context3.next = 6;
                break;

              case 21:
                _context3.next = 27;
                break;

              case 23:
                _context3.prev = 23;
                _context3.t0 = _context3['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 27:
                _context3.prev = 27;
                _context3.prev = 28;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 30:
                _context3.prev = 30;

                if (!_didIteratorError) {
                  _context3.next = 33;
                  break;
                }

                throw _iteratorError;

              case 33:
                return _context3.finish(30);

              case 34:
                return _context3.finish(27);

              case 35:
                return _context3.abrupt('return', applicantList);

              case 36:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 23, 27, 35], [28,, 30, 34]]);
      }));

      function getApplicantList(_x) {
        return _ref3.apply(this, arguments);
      }

      return getApplicantList;
    }(),


    // ================= POP UP MODAL PANEL ==================
    popModal: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(item, key, button) {
        var manager, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, m, info;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('key of table items.id == user\n', item.id);
                console.log('key of table key\n', key);
                console.log('key of table button\n', button);
                console.log('\n\n====== ApplicantList.vue - Current this.modalInfo.content ======\n', this.modalInfo.content, '\n ==========');

                this.$store.commit('setCurrentPendingUploadFileUser', item);

                manager = null;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 9;


                for (_iterator2 = _getIterator(this.$store.state.currentMsManagerList); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  m = _step2.value;

                  if (m.id == 'userMsManager' + item.id) {
                    manager = m;
                  }
                }

                _context4.next = 17;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](9);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 17:
                _context4.prev = 17;
                _context4.prev = 18;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 20:
                _context4.prev = 20;

                if (!_didIteratorError2) {
                  _context4.next = 23;
                  break;
                }

                throw _iteratorError2;

              case 23:
                return _context4.finish(20);

              case 24:
                return _context4.finish(17);

              case 25:
                this.modalInfo.title = item.fullname + ' | ' + item.nricFin + ' | File Uploaded';
                this.modalInfo.content = _defineProperty({}, 'fileList', [].concat(_toConsumableArray(manager.internalTrainingFiles)));

                _context4.next = 29;
                return axios.post('/userMsManager/trainingFileUpload/setApplicant', { applicantId: item.id, applicantNricFin: item.nricFin }, { withCredentials: true });

              case 29:
                info = _context4.sent.data;

                console.log('\n\n ======== INFO ======= \n', info, '\n ============');

                this.initApplicants();
                this.$root.$emit('bv::show::modal', 'modalInfo', button);

              case 33:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[9, 13, 17, 25], [18,, 20, 24]]);
      }));

      function popModal(_x2, _x3, _x4) {
        return _ref4.apply(this, arguments);
      }

      return popModal;
    }(),


    // ============ Upload Files ===========
    uploadTrainingFiles: function uploadTrainingFiles(pdfFile) {
      console.log('\n\n ====== ApplicantList <|-- uploadTrainingFiles pdffiles====== \n', pdfFile, '\n -------------------------');

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = _getIterator(pdfFile), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var pdf = _step3.value;

          if (!this.modalInfo.content['fileList'].includes(pdf)) {
            this.modalInfo.content['fileList'].push(pdf);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },


    // ============ Update the msStatus -> 101 pending approval ==========
    submitForApproval: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var moduleSessionId, moduleSession, userActorId, msStatusId, moduleSessionActorId, msStatus;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                moduleSessionId = this.$store.state.currentModuleSession.id;
                moduleSession = this.$store.state.currentModuleSession;
                userActorId = this.$store.state.currentPendingUploadFileUser.id;
                msStatusId = 'msStatus' + moduleSessionId + userActorId;
                moduleSessionActorId = moduleSessionId;

                console.log('\n\n ======== applicant List msStatusId ========\n', msStatusId, '\n ==============');

                alert('Booking is in progress.\n\n To check sucessfull booking? Go to Dashboard >>View >>View Session Detail for more detail. \n\nThank you.');

                _context5.next = 9;
                return axios.post('/userMsManager/submitTrainingFileForApproval', { msStatusId: msStatusId, moduleSessionActorId: moduleSessionActorId, moduleSession: moduleSession });

              case 9:
                msStatus = _context5.sent.data;


                console.log('\n\n ======== applicant List msStatus obtained ========\n', msStatus, '\n ==============');
                alert(msStatus);
                if (msStatus === "Fully Booked") {
                  alert("We are sorry. This session is fully booked.");
                } else {
                  this.initApplicants();
                  this.$refs.fileUploadModal.hide();
                  this.$parent.getReloadedData();
                }

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function submitForApproval() {
        return _ref5.apply(this, arguments);
      }

      return submitForApproval;
    }(),

    // ============ CANCEL BOOKING ==============
    cancelBooking: function cancelBooking(item, key) {
      this.$emit('cancelBooking', { item: item, key: key });
      console.log('key: ', key, 'item: ', item);
    },
    hideModal: function hideModal() {
      this.$refs.fileUploadModal.hide();
      this.initApplicants();
      this.resetModal();
    },
    resetModal: function resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/mainPage/bookModuleSession/ApplicantList.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/mainPage/bookModuleSession/ApplicantList.vue
// module chunks = 8